<template>
  <div v-if="hide === false">
    <ProgressLabelItem
      :label="label"
      :color="color"
    />
    <div class="cxm-ProgressLabelInfo">
      <Typography
        size="xs"
        weight="500"
        data-testid="progress-label-info-amount"
      >
        {{ localeAmount }}
      </Typography>
      <Divider
        v-if="extra === false"
        vertical
        spacing="sm"
      />
      <Typography
        size="xs"
        weight="500"
        data-testid="progress-label-info-percentage"
      >
        {{ percentage }}
      </Typography>
    </div>
  </div>
</template>

<script>
import Divider from '@/packages/ui/components/Divider/Divider.vue';
import Typography from '@/packages/ui/components/Typography/Typography.vue';
import ProgressLabelItem from './ProgressLabelItem.vue';

export default {
  name: 'ProgressLabelInfo',
  components: {
    Divider,
    ProgressLabelItem,
    Typography,
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    },
    percentage: {
      type: String,
      default: '0',
    },
    amount: {
      type: [Number, String],
      default: 0,
    },
    hide: {
      type: Boolean,
      default: false,
    },
    extra: {
      type: Boolean,
      default: false,
    },
    locale: {
      type: String,
      default: 'pt-BR',
    },
  },
  computed: {
    localeAmount() {
      return this.amount.toLocaleString(this.locale);
    },
  },
};
</script>

<style lang="scss" scoped>
  .cxm-ProgressLabelInfo {
    display: flex;
    align-items: center;
    height: 20px;
    margin-top: var(--track-spacing-xs);
    margin-left: var(--track-spacing-md)
  }
</style>
